import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()

export class NavigationProvider {

    currentPage = new BehaviorSubject<string>('');
    public $currentPage = this.currentPage.asObservable();
    previousPage = new BehaviorSubject<string>('');
    public $previousPage = this.previousPage.asObservable();

    constructor() {}

    setCurrentPage (page: string) {
        this.currentPage.next(page);
    }

    setPreviousPage (page: string) {
        this.previousPage.next(page);
    }
}


// WEBPACK FOOTER //
// ./src/providers/navigation.ts